import styles from './EditProjectDocumentModal.module.css';

import { observer } from 'mobx-react-lite';
import { projectsStore } from '../../../../../store/mobx/projects.store';
import Modal from 'ui/Modal';
import FileUploader from 'ui/FileUploader';
import { useState } from 'react';
import useAlert from 'hooks/useAlert';

const EditProjectDocumentModal = observer(({ setModalOpened }) => {
  const { showAlert } = useAlert();
  const { selectedProject, upsertProjectDocument, removeProjectDocument } = projectsStore;

  const [initialFiles] = useState(() =>
    selectedProject.files.map((file) => ({
      name: file.file?.split('/').pop(),
      id: file.id,
    })),
  );
  const [error, setError] = useState();

  const closeModal = () => {
    setError(null);
    setModalOpened(false);
  };

  const handleAddDocument = async (files) => {
    if (files.length <= selectedProject.files.length) return;

    const idProject = selectedProject.id;
    const uploadedFile = files[files.length - 1];

    if (!uploadedFile) return;

    const response = await upsertProjectDocument(idProject, uploadedFile);

    if (!response.success && response.error_code)
      return errorCommonAlert(response.error_code, response.error);

    setError(null);
  };

  const handleRemoveDocument = async (index) => {
    setError(null);
    const file = selectedProject.files[index];
    if (file) {
      await removeProjectDocument(file.id);
    }
  };

  const errorCommonAlert = (code, message) => {
    showAlert(`Код № ${code}${message ? ` - ${message}` : ''}.`, 'error');
  };

  return (
    <Modal hideDefaultFooter={true} title="Редактирование документов" onClose={closeModal}>
      <FileUploader
        initialFiles={initialFiles}
        multiple={false}
        listPosition="bottom"
        onFilesChange={(files) => handleAddDocument(files)}
        onFileRemove={(index) => handleRemoveDocument(index)}
        customStyles={{ mainContainer: styles.mainContainer }}
        onError={(error) => setError(error)}
      />
      <div className={styles.error}>{error}</div>
    </Modal>
  );
});

export default EditProjectDocumentModal;